import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const DeleteSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default DeleteSVG;
